import { render, staticRenderFns } from "./mobile-prefix-list.vue?vue&type=template&id=14f17466&scoped=true"
import script from "./mobile-prefix-list.vue?vue&type=script&lang=js"
export * from "./mobile-prefix-list.vue?vue&type=script&lang=js"
import style0 from "./mobile-prefix-list.vue?vue&type=style&index=0&id=14f17466&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f17466",
  null
  
)

export default component.exports